import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, Row, Col } from 'antd'
import { SyncOutlined, RedoOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
// import _ from 'lodash'
import { messageModal, modalError } from '@/utils/modalUtils'
import { getWaveRunList, getWaveRunListTotal, refreshWaveRun, manualUpdateWaveRun } from '@/services/wave/wave'
import { getWaveRunUpdateTime } from '@/services/sku/sku'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import { paginationInit, formatMessageNew, dateFormatYearMonthDay, dateFormatYearMonthDayTime } from '@/utils/common'
const startMonth = dayjs().subtract(7, 'day')
const endMonth = dayjs()
// import { ACTIVE_STATUS } from '../../utils/types'

// const activeStatusObj = initCurryingObj(ACTIVE_STATUS)

const WavePage = props => {
  let formRef = useRef(null)
  let inputRef = useRef(null)
  const mounting = useRef(false)
  const [tableList, setTableList] = useState([])
  const [tableListTotal, setTableListTotal] = useState([])

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const startTime = info.timeRange && info.timeRange[0] ? info.timeRange[0].format(dateFormatYearMonthDay) : null
    const endTime = info.timeRange && info.timeRange[1] ? info.timeRange[1].format(dateFormatYearMonthDay) : null
    const params = {
      ...info,
      flushTimeStart: startTime,
      flushTimeEnd: endTime
    }
    delete params.timeRange
    return params
  }
  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    delete params.timeRange
    getWaveRunListTotal(params).then(res => {
      console.log(res)
      const dt = res.resultData
      const keys = Object.keys(dt)
      const list = keys.map((key, index) => ({ key: index, tagType: key, productQuantity: dt[key] }))
      setTableListTotal(list)
    })
    getWaveRunList(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
      inputRef.current.focus({
        cursor: 'all'
      })
    })
  }

  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.waverun.run',
      key: 'runBatch',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.waverun.carton',
      key: 'carton',
      initialValues: '',
      isdefaultfilter: 'true',
      placeholder: formatMessageNew('languageObj.waverun.scan'),
      refValue: inputRef,
      returnCallback: searchDataFun,
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.waverun.type',
      key: 'productType',
      allowClear: true,
      initialValues: null,
      isdefaultfilter: 'true',
      selectList: [
        { value: 'NFC', label: 'NFC' },
        { value: 'RFID', label: 'RFID' },
        { value: 'NORMAL', label: 'NORMAL' }
      ],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.waverun.plant',
      key: 'plant',
      allowClear: true,
      initialValues: null,
      isdefaultfilter: 'true',
      selectList: [
        { value: '1025', label: '1025' },
        { value: '1027', label: '1027' }
      ],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.waverun.product',
      key: 'productCode',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.waverun.waveRunDate',
      key: 'timeRange',
      format: dateFormatYearMonthDay,
      isdefaultfilter: 'true',
      disabledDate: current => {
        let falg =
          (current &&
            current <
              dayjs()
                .subtract(7, 'day')
                .subtract(1, 'day')) ||
          (current && current > dayjs().endOf('day'))
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.waverun.salesOrderType',
      key: 'salesOrderType',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.waverun.status',
      key: 'tagStatus',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.waverun.tagType',
      key: 'tagType',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  //   const [searchList, setSearchList] = useState(searchListInit)
  const [updateTime, setUpdateTime] = useState(0)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const tableColumnsTotal = [
    {
      title: formatMessageNew('languageObj.waverun.tagType'),
      dataIndex: 'tagType',
      render: text => {
        if (!text) {
          return <div className="word_break_word">{formatMessageNew('languageObj.waverun.noTagTypeProduct')}</div>
        }
        const ls = text.split(',')
        return ls.map((item, idx) => {
          const arr = item.split('-')
          return (
            <div key={idx} className="word_break_word">
              <span className="tagType">{arr[0]}</span>
              <span className="splitSpan">-</span>
              {arr[1]}
              {idx < ls.length - 1 ? ',' : ''}
            </div>
          )
        })
      }
    },
    {
      title: formatMessageNew('languageObj.waverun.productQuantity'),
      dataIndex: 'productQuantity'
    }
  ]
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.waverun.run'),
      dataIndex: 'runBatch'
    },
    {
      title: formatMessageNew('languageObj.waverun.carton'),
      dataIndex: 'carton'
    },
    {
      title: formatMessageNew('languageObj.waverun.plant'),
      dataIndex: 'plant'
    },
    {
      title: formatMessageNew('languageObj.waverun.product'),
      dataIndex: 'productCode'
    },
    {
      title: formatMessageNew('languageObj.waverun.size'),
      dataIndex: 'productSize'
    },
    {
      title: formatMessageNew('languageObj.waverun.salesOrderType'),
      dataIndex: 'salesOrderType'
    },
    {
      title: formatMessageNew('languageObj.waverun.qty'),
      dataIndex: 'unitsQuantity'
    },
    {
      title: formatMessageNew('languageObj.waverun.rfid'),
      dataIndex: 'rfid'
    },
    {
      title: formatMessageNew('languageObj.waverun.nfc'),
      dataIndex: 'nfc'
    },
    {
      title: formatMessageNew('languageObj.waverun.tagType'),
      dataIndex: 'type',
      render: (text, record) => {
        if (!text) return <div className="word_break_word">{text}</div>
        let ls = text.split(',')
        let tagTypeDesc = record.description.split(',')
        return ls.map((item, idx) => {
          return (
            <div key={idx} className="word_break_word">
              <span className="tagType">{item}</span>
              <span className="splitSpan">-</span>
              {tagTypeDesc[idx]}
              {idx < ls.length - 1 ? ',' : ''}
            </div>
          )
        })
      }
    },
    {
      title: formatMessageNew('languageObj.waverun.normal'),
      dataIndex: 'normal'
    },
    {
      title: formatMessageNew('languageObj.waverun.status'),
      dataIndex: 'tagStatus'
      // render: text => {
      //   if (text) {
      //     return activeStatusObj['Active']
      //   } else {
      //     return activeStatusObj['Disabled']
      //   }
      // }
    },
    {
      title: formatMessageNew('languageObj.waverun.waveRunDate'),
      dataIndex: 'createTime',
      render: text => {
        return dayjs(new Date(text)).format(dateFormatYearMonthDay)
      }
    }
  ]
  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  useEffect(() => {
    lastUpdateTime()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const lastUpdateTime = () => {
    getWaveRunUpdateTime({}).then(res => {
      if (res?.resultData > 0) {
        setUpdateTime(res.resultData)
      }
    })
  }

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus({ cursor: 'all' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    mounting.current = true
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    // formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1,
      total: 0
    }
    setPagination(pg)
    // setQueryFlag(!queryFlag)
    setTableList([])
    setTableListTotal([])
    formRef && formRef.current.setValue({ timeRange: [] })
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const refreshDataBtn = () => {
    refreshWaveRun({})
      .then(res => {
        messageModal('success', {
          content: formatMessageNew('languageObj.commonLocale.success')
        })
        // setQueryFlag(!queryFlag)
        // searchDataFun()
        lastUpdateTime()
      })
      .catch(error => {
        //Read multiple files. There will be partial success
        lastUpdateTime()
      })
  }
  const manualUpdateWaveRunFun = () => {
    manualUpdateWaveRun()
      .then(res => {
        messageModal('success', {
          content: formatMessageNew('languageObj.commonLocale.success')
        })
      })
      .catch(error => {
        let str = formatMessageNew('languageObj.waverun.errorcode_' + error.errorCode)
        modalError({
          content: str || error.errorMessage
        })
      })
  }

  const getUpdateHtml = () => {
    return (
      <div>
        {updateTime !== 0 ? (
          <div style={{ marginRight: '20px', display: 'flex', alignItems: 'center' }}>
            {formatMessageNew('languageObj.waverun.updatedTime')}
            {dayjs(new Date(updateTime)).format(dateFormatYearMonthDayTime)}
          </div>
        ) : null}
      </div>
    )
  }

  return (
    <Card bordered={false} bodyStyle={{ padding: 4 }}>
      <div className="search-bar">
        <SearchBar
          ref={formRef}
          searchList={searchListInit}
          showCollapseBtn={true}
          showSearchBtn={true}
          showClearBtn={true}
          onSearch={searchDataBtn}
          onClear={searchClearDataBtn}
        />
      </div>
      <div className="content-container">
        <Row type="flex" justify="center">
          <Col span={16}>
            <AntdTable bordered columns={tableColumnsTotal} dataSource={tableListTotal} />
          </Col>
        </Row>
        <div className="opt_btn mb15 mt15" style={{ display: 'flex', alignItems: 'center' }}>
          {getUpdateHtml()}
          <div style={{ paddingLeft: 16, display: 'flex', justifyContent: 'flex-start' }}>
            <Button type="primary" onClick={refreshDataBtn}>
              <SyncOutlined />
              {formatMessageNew('languageObj.nspskuLocale.refreshWaveRun')}
            </Button>
            <Button className="ml20" type="primary" onClick={manualUpdateWaveRunFun}>
              <RedoOutlined />
              {formatMessageNew('languageObj.waverun.manualUpdateWaveRun')}
            </Button>
          </div>
        </div>
        <AntdTable
          dataSource={tableList}
          columns={tableColumns}
          // 独一无二的标识，不能重复
          columnsKey="nddcWaveRunReportColumns"
          pagination={pagination}
          onChange={handleTableChange}
        />
      </div>
    </Card>
  )
}
export default WavePage
